import { all } from 'redux-saga/effects'

//public
import loginSaga from './auth/login/saga';
import forgetSaga from './auth/forgetpwd/saga';
import LayoutSaga from './layout/saga';
import UserSaga from './user/saga';
import RoleSaga from './role/saga';
import SupportSaga from './support/saga';
import ProfileSaga from './profile/saga';
import CustomerSaga from './customers/saga';
import GeneralSaga from './general/saga';
import DashboardSaga from './dashboard/saga';
import InventorySaga from './inventory/saga';
import VoucherSaga from './voucher/saga';
import ProductSaga from './product/saga';
import PromocodeSaga from './promoCode/saga';
import ReportSaga from './report/saga';
import CategorySaga from './category/saga';
import SchoolSaga from './school/saga';
import ManufacturerSaga from './manufacturer/saga';
import ModelSaga from './model/saga';
import ServiceSaga from './service/saga';
import ServiceTypeSaga from './servicetype/saga';
import ShippingSaga from './shipping/saga';
import ShippingRateSaga from './shippingrate/saga';
import SettingSaga from './setting/saga';
import PermissionSaga from './permission/saga';
import ConfigurationSaga from './configuration/saga';
import PaymentSaga from './payment/saga';
import ReviewSaga from './review/saga';
import OrderSaga from './order/saga';
import BannerSaga from './banner/saga';


export default function* rootSaga() {
    yield all([
        //public
        loginSaga(),
        UserSaga(),
        GeneralSaga(),
        CustomerSaga(),
        VoucherSaga(),
        RoleSaga(),
        SupportSaga(),
        PermissionSaga(),
        ProfileSaga(),
        PromocodeSaga(),
        forgetSaga(),
        ProductSaga(),
        LayoutSaga(),
        DashboardSaga(),
        InventorySaga(),
        ReportSaga(),
        PaymentSaga(),
        ReviewSaga(),
        OrderSaga(),
        BannerSaga(),

        //Setting
        SettingSaga(),
        CategorySaga(),
        SchoolSaga(),
        ConfigurationSaga(),
        ManufacturerSaga(),
        ModelSaga(),
        ServiceSaga(),
        ServiceTypeSaga(),
        ShippingSaga(),
        ShippingRateSaga(),
    ])
}